import React, { useState, useEffect, useRef } from 'react';
import Header from '../components/header';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faSearch } from '@fortawesome/free-solid-svg-icons';
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import BaseURL from '../assets/contants/BaseURL';
import axios from 'axios';
import '../scss/Proreport.scss';
import * as ExcelJS from 'exceljs';


const AlertReports = () => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [alertReports, setAlertReports] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [searchMeter, setSearchMeter] = useState('');
  const [filteredMeters, setFilteredMeters] = useState([]);
  const [allMeters, setAllMeters] = useState([]);
  const [selectedMeter, setSelectedMeter] = useState("Select Meter");
  const dropdownRef = useRef(null);
  const [alertDetails, setAlertDetails] = useState({
    message: '',
    user: '',
    minValue: '',
    maxValue: '',
    meterId: '',
    parameterName: ''
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


  useEffect(() => {
    const fetchMeters = async () => {
      try {
        const metersResponse = await axios.get(`${BaseURL}meters/energymeters/`);
        const meters = metersResponse.data;
        setAllMeters(meters);
        setFilteredMeters(meters);
      } catch (error) {
        console.error("Error fetching meter data:", error);
      }
    };

    fetchMeters();
  }, []);


  const handleSearch = (query) => {
    setSearchMeter(query);
    if (query.trim() === '') {
      setFilteredMeters(allMeters);
    } else {
      const filtered = allMeters.filter((meter) =>
        meter.meter_name.toLowerCase().includes(query.toLowerCase()) ||
        meter.meter_id.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredMeters(filtered);
    }
  };

  const handleMeterSelect = (meter) => {
    setSelectedMeter(`${meter.meter_id} - ${meter.meter_name}`);
    setIsOpen(false);
  };

  const handleDownload = () => {
    handleExportExcel(alertReports);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchMeter('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleRowClick = (message, minValue, maxValue, user, parameterName, meterId) => {
    setAlertDetails({ message, minValue, maxValue, user, parameterName, meterId });
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const modalRef = useRef(null);


  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setShowModal(false);
    }
  };

  useEffect(() => {
    if (showModal) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showModal]);

  const totalPages = Math.ceil(alertReports.length / itemsPerPage);
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const pageData = alertReports.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleSearchClick = async () => {
    if (!selectedMeter || selectedMeter === "Select Meter" || !fromDate || !toDate) {
      alert("Please select a meter and date range.");
      return;
    }

    const meterId = selectedMeter.split(" - ")[0];
    const payload = {
      meter_id: meterId,
      from_date: fromDate.toISOString().split("T")[0],
      to_date: toDate.toISOString().split("T")[0],
    };

    const token = sessionStorage.getItem('token');

    if (!token) {
      alert("User is not authenticated.");
      return;
    }

    try {
      const response = await axios.post(`${BaseURL}alerts/alert-reports/`, payload, {
        headers: {
          Authorization: `Token ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const formattedReports = response.data.dates_list.map((date, index) => ({
        date,
        meter_id: meterId,
        time: response.data.time_list[index],
        msg: response.data.msg[index],
        trigger: response.data.trigger[index],
        actual_value: response.data.actual_values[index],
        max_value: response.data.max_values[index],
        min_value: response.data.min_values[index],
        parameter_name: response.data.parameter_names[index],
        users: response.data.users.map(user => user.username)[index],
      }));
      setAlertReports(formattedReports);
    } catch (err) {
      console.error("Error fetching alert reports:", err);
    }
  };
  const handleExportExcel = async (data) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Alert Reports');

    for (let rowNum = 1; rowNum <= 3; rowNum++) {
      const row = worksheet.getRow(rowNum);
      for (let i = 1; i <= 8; i++) {
        row.getCell(i).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFDDDDDD' },
        };
      }
    }

    try {
      const getBase64FromImageUrl = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result.split(',')[1]);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      };

      const logoBase64 = await getBase64FromImageUrl('/brad.png');
      const logoId = workbook.addImage({
        base64: logoBase64,
        extension: 'png'
      });

      const centerCol = Math.floor(9 / 2) - 1;
      worksheet.addImage(logoId, {
        tl: { col: centerCol + 1, row: 0 },
        br: { col: centerCol + 2, row: 3 },
        editAs: 'oneCell'
      });

      worksheet.getRow(1).height = 30;
      worksheet.getRow(2).height = 30;
      worksheet.getRow(3).height = 30;

      worksheet.getColumn(centerCol + 1).width = 30;
      worksheet.getColumn(centerCol + 2).width = 30;
    } catch (error) {
      console.error('Error adding logo:', error);
    }

    worksheet.getColumn(1).width = 10;
    worksheet.getColumn(2).width = 15;
    worksheet.getColumn(3).width = 15;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 25;
    worksheet.getColumn(6).width = 15;
    worksheet.getColumn(7).width = 15;
    worksheet.getColumn(8).width = 15;

    const date = new Date().toISOString().split('T')[0];
    const dateRow = worksheet.addRow([`Report Date: ${date}`]);
    worksheet.mergeCells(dateRow.number, 1, dateRow.number, 8);
    dateRow.font = { bold: true, size: 14 };
    dateRow.alignment = { horizontal: 'center', vertical: 'middle' };

    [1, 2, 3, 4, 5, 6, 7, 8].forEach((col) => {
      worksheet.getCell(dateRow.number, col).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD9EAD3' },
      };
    });

    const meterId = selectedMeter.split(" - ")[0];
    const meterName = selectedMeter.split(" - ")[1] || '';
    const branchRow = worksheet.addRow(['Site: Coimbatore', `Meter ID: ${meterId}`, '', `Meter Name: ${meterName}`]);
    branchRow.font = { bold: true, size: 12 };
    branchRow.getCell(1).alignment = { horizontal: 'left' };
    branchRow.getCell(3).alignment = { horizontal: 'center' };
    [1, 2, 3, 4, 5, 6, 7, 8].forEach((col) => {
      const cell = worksheet.getCell(branchRow.number, col);
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD9D9D9' },
      };
    });

    const titleRow = worksheet.addRow(['Alert Reports']);
    worksheet.mergeCells(titleRow.number, 1, titleRow.number, 8);
    titleRow.font = { bold: true, size: 16 };
    titleRow.alignment = { horizontal: 'center', vertical: 'middle' };

    [1, 2, 3, 4, 5, 6, 7, 8].forEach((col) => {
      worksheet.getCell(titleRow.number, col).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF1E90FF' },
      };
    });

    const headers = ['S.No', 'Date', 'Time', 'Meter ID', 'Parameter Name', 'Min Value', 'Max Value', 'Actual Value'];
    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFA500' },
      };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    if (data.length > 0) {
      data.forEach((row, index) => {
        const rowData = [
          index + 1,
          row.date,
          row.time,
          row.meter_id,
          row.parameter_name,
          row.min_value,
          row.max_value,
          row.actual_value
        ];
        const dataRow = worksheet.addRow(rowData);

        dataRow.eachCell((cell, colIndex) => {
          const fillColor = index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF';
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: fillColor },
          };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
      });
    } else {
      const noDataRow = worksheet.addRow(['No data available']);
      worksheet.mergeCells(noDataRow.number, 1, noDataRow.number, 8);
      noDataRow.font = { italic: true };
      noDataRow.alignment = { horizontal: 'center', vertical: 'middle' };
    }

    const footerRow = worksheet.addRow(['Powered by Innospace']);
    footerRow.font = { bold: true, size: 12 };
    footerRow.alignment = { horizontal: 'center', vertical: 'middle' };
    worksheet.mergeCells(footerRow.number, 1, footerRow.number, 8);

    for (let i = 1; i <= 8; i++) {
      footerRow.getCell(i).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFDDDDDD' },
      };
    }

    const reportName = 'Alert_Reports';
    const fileName = `${reportName}_${meterId}_${fromDate.toISOString().split('T')[0]}_to_${toDate.toISOString().split('T')[0]}.xlsx`;

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  };

  return (
    <div style={{ textAlign: 'center', width: '100%' }}>
      <div style={{
        backgroundColor: '#007acc',
        color: 'white',
        alignContent: 'center',
        fontSize: '14px',
        height: '40px'
      }}>
        <Header title="ALERT REPORTS" />
      </div>
      <div style={{
        border: '1px solid #ccc',
        padding: '10px',
        marginTop: '20px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'white',
        maxWidth: '980px',
        marginLeft: 'auto',
        marginRight: 'auto',
        borderRadius: '8px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <label style={{ fontWeight: "bold" }}>From Date:</label>
              <Datetime
                selected={fromDate}
                onChange={(date) => setFromDate(date)}
                inputProps={{
                  placeholder: "Select From Date Time",
                  style: { borderRadius: "10px", border: "1px solid #ccc", padding: "10px", width: "80%",boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"  }
                }}
              />

              <label style={{ fontWeight: "bold" }}>To Date:</label>
              <Datetime
                selected={toDate}
                onChange={(date) => setToDate(date)}
                inputProps={{
                  placeholder: "Select To Date Time",
                  style: { borderRadius: "10px", border: "1px solid #ccc", padding: "10px", width: "80%",boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"  }
                }}
              />
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '-10px' }}>
            <div style={{ display: 'flex', gap: '20px', width: '100%' }}>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    width: '95%',
                    padding: '6px',
                    borderRadius: '8px',
                    border: '1px solid #ccc',
                    position: 'relative',
                    marginBottom: '10px',
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" 
                  }}
                >
                  <div
                    onClick={() => setIsOpen(!isOpen)}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      cursor: 'pointer',
                      width: '160px',
                      fontSize: '12px',
                      padding: "5px"
                    }}
                  >
                    <span style={{ flex: 1, textAlign: 'left' }}>{selectedMeter}</span>
                    <span style={{ fontSize: '10px' }}>
                      <i className="fa-solid fa-angle-down"></i>
                    </span>
                  </div>

                  {isOpen && (
                    <div ref={dropdownRef}
                      style={{
                        position: 'absolute',
                        top: '110%',
                        left: 0,
                        right: 0,
                        backgroundColor: 'white',
                        borderRadius: '5px',
                        boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
                        zIndex: 10,
                        maxHeight: '330px',
                        overflowY: 'auto',
                        border: '1px solid #000',
                      }}
                    >
                      <div
                        style={{
                          padding: '10px',
                          borderBottom: '1px solid #ccc',
                        }}
                      >
                        <input
                          type="text"
                          placeholder="Search Meter ID"
                          value={searchMeter}
                          onChange={(e) => {
                            setSearchMeter(e.target.value);
                            handleSearch(e.target.value);
                          }}
                          style={{
                            width: '90%',
                            padding: '8px',
                            borderRadius: '5px',
                            border: '1px solid #ccc',
                          }}
                        />
                      </div>
                      {filteredMeters.length > 0 ? (
                        filteredMeters.map((meter) => (
                          <div
                            key={`${meter.meter_id}-${meter.meter_name}`}
                            style={{
                              padding: '5px',
                              cursor: 'pointer',
                              textAlign: 'left',
                              fontSize: '12px',
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = '#006ec5';
                              e.target.style.color = 'white';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = 'transparent';
                              e.target.style.color = 'black';
                            }}
                            onClick={() => handleMeterSelect(meter)}
                          >
                            {meter.meter_id} - {meter.meter_name}
                          </div>
                        ))
                      ) : (
                        <div style={{ padding: '10px' }}>No results found</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

          </div>
          <button
            style={{
              padding: '8px 12px',
              backgroundColor: '#007acc',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              borderRadius: '8px',
            }}
            onClick={handleSearchClick}
          >
            <FontAwesomeIcon icon={faSearch} />
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <button style={{
              display: 'flex',
              alignItems: 'center',
              padding: '8px 10px',
              backgroundColor: '#007acc',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              borderRadius: '8px',
              width: '95px'
            }} onClick={handleDownload}
            >
              <span>Download</span>
              <FontAwesomeIcon icon={faDownload} style={{ marginLeft: '5px' }} />
            </button>
          </div>
        </div>
      </div>
      <div className="dashboards">
      <div className="Monthly-Reports">
      <div className="table-container">
        <table>
          <thead>
            <tr style={{ backgroundColor: '#007acc', color: 'white' }}>
              <th>S.No</th>
              <th>Date</th>
              <th>Time</th>
              <th>Meter ID</th>
              <th>Parameter Name</th>
              <th>Min Value</th>
              <th>Max Value</th>
              <th>Actual Value</th>
            </tr>
          </thead>
          <tbody>
            {pageData.map((alert, index) => (
              <tr key={`${alert.date}-${alert.time}`} onClick={() => handleRowClick(alert.msg, alert.min_value, alert.max_value, alert.users, alert.parameter_name, alert.meter_id)} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : '#ffffff', cursor: 'pointer' }}>
                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td>{alert.date}</td>
                <td>{alert.time}</td>
                <td>{alert.meter_id}</td>
                <td>{alert.parameter_name}</td>
                <td>{alert.min_value}</td>
                <td>{alert.max_value}</td>
                <td>{alert.actual_value}</td>
              </tr>
            ))}
            {pageData.length === 0 && (
              <tr>
                <td colSpan="8" style={{ textAlign: 'center' }}>
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={{
              margin: '0 5px',
              padding: '5px 10px',
              background: '#007acc',
              color: currentPage === 1 ? '#9e9e9e' : '#ffffff',
              border: 'none',
              borderRadius: '25px',
              cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
              fontSize: '12px',
            }}
          >
            Previous
          </button>

          {currentPage > 3 && (
            <button
              onClick={() => handlePageChange(1)}
              style={{
                margin: '0 5px',
                padding: '5px 10px',
                background: currentPage === 1 ? '#007acc' : '#e0e0e0',
                color: currentPage === 1 ? '#ffffff' : '#333333',
                border: '1px solid #ddd',
                borderRadius: '25px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
            >
              1
            </button>
          )}

          {currentPage > 3 && <span style={{ margin: '0 5px', fontSize: '14px', color: '#333' }}>......</span>}
          {Array.from({ length: totalPages }, (_, i) => {
            const startPage = Math.max(1, currentPage - 2);
            const endPage = Math.min(totalPages, currentPage + 2);

            if (i + 1 >= startPage && i + 1 <= endPage) {
              return (
                <button
                  key={i}
                  onClick={() => handlePageChange(i + 1)}
                  style={{
                    margin: '0 5px',
                    padding: '5px 10px',
                    background: currentPage === i + 1 ? '#007acc' : '#e0e0e0',
                    color: currentPage === i + 1 ? '#ffffff' : '#333333',
                    border: '1px solid #ddd',
                    borderRadius: '25px',
                    cursor: 'pointer',
                    fontSize: '12px',
                  }}
                >
                  {i + 1}
                </button>
              );
            }
            return null;
          })}

          {currentPage < totalPages - 2 && (
            <span style={{ margin: '0 5px', fontSize: '14px', color: '#333' }}>......</span>
          )}

          {currentPage < totalPages - 2 && (
            <button
              onClick={() => handlePageChange(totalPages)}
              style={{
                margin: '0 5px',
                padding: '5px 10px',
                background: currentPage === totalPages ? '#007acc' : '#e0e0e0',
                color: currentPage === totalPages ? '#ffffff' : '#333333',
                border: '1px solid #ddd',
                borderRadius: '25px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
            >
              {totalPages}
            </button>
          )}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={{
              margin: '0 5px',
              padding: '5px 10px',
              background: '#007acc',
              color: currentPage === totalPages ? '#9e9e9e' : '#ffffff',
              border: 'none',
              borderRadius: '25px',
              cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
              fontSize: '12px',
            }}
          >
            Next
          </button>
        </div>
      </div>
      </div>
      </div>

      {showModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            ref={modalRef}
            style={{
              backgroundColor: 'white',
              padding: '25px',
              borderRadius: '10px',
              boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
              maxWidth: '600px',
              maxHeight: '70vh',
              overflowY: 'auto',
              width: '100%',
            }}
          >
            <h3 style={{ marginBottom: '20px', textAlign: 'center', color: '#333' }}>
              Alert Details
            </h3>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '-10px' }}>
              <div style={{ flex: '1', marginRight: '10px' }}>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                    Meter ID
                  </label>
                  <div
                    style={{
                      padding: '10px',
                      borderRadius: '5px',
                      border: '1px solid #ccc',
                      backgroundColor: '#f9f9f9',
                    }}
                  >
                    {alertDetails.meterId || 'N/A'}
                  </div>
                </div>
              </div>
              <div style={{ flex: '1', marginLeft: '10px' }}>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                    Parameter Name
                  </label>
                  <div
                    style={{
                      padding: '10px',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      backgroundColor: '#f9f9f9',
                    }}
                  >
                    {alertDetails.parameterName || 'N/A'}
                  </div>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '-10px' }}>
              <div style={{ flex: '1', marginRight: '10px' }}>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                    Min Value
                  </label>
                  <div
                    style={{
                      padding: '10px',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      backgroundColor: '#f9f9f9',
                    }}
                  >
                    {alertDetails.minValue || 'N/A'}
                  </div>
                </div>
              </div>
              <div style={{ flex: '1', marginLeft: '10px' }}>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                    Max Value
                  </label>
                  <div
                    style={{
                      padding: '10px',
                      borderRadius: '5px',
                      border: '1px solid #ccc',
                      backgroundColor: '#f9f9f9',
                    }}
                  >
                    {alertDetails.maxValue || 'N/A'}
                  </div>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', marginBottom: '20px' }}>
              <div style={{ width: '48%', marginRight: '4%' }}>
                <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                  User select
                </label>
                <div
                  style={{
                    width: '95%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    height: '100px',
                    overflowY: 'auto',
                    backgroundColor: '#f9f9f9',
                  }}
                >
                  <select
                    multiple
                    style={{
                      width: '100%',
                      height: '100%',
                      border: 'none',
                      outline: 'none',
                      backgroundColor: 'inherit',
                    }}
                  >

                    <option value={alertDetails.user || 'N/A'}>
                      {alertDetails.user || 'N/A'}
                    </option>
                  </select>
                </div>
              </div>

              {/* Message Field */}
              <div style={{ width: '48%' }}>
                <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                  Message
                </label>
                <div
                  style={{
                    width: '92%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    backgroundColor: '#f9f9f9',
                    minHeight: '100px',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  {alertDetails.message || 'No message entered'}
                </div>
              </div>
            </div>



            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', gap: '15px' }}>
              <button
                style={{
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  width: '20%',
                }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>

        </div>
      )}

    </div>
  );
};

export default AlertReports;